import Icon_download from "./Icon_download"
import Spinner from "./Spinner"

const PRIMARY_COLOR = "#3004C7"
const FOCUS_RING_COLOR = "rgba(48, 4, 199, 0.45)"
const FOCUS_RING_VISIBLE_COLOR = "rgba(48, 4, 199, 0.65)"

const ActionButton = ({ label, onClick, isCaching, disabled }) => (
  <button
    onClick={() => {
      if (!disabled) onClick()
    }}
    tabIndex={0}
    disabled={disabled}
    css={{
      userSelect: "none",
      display: "flex",
      minHeight: 48,
      width: "100%",
      alignItems: "center",
      gap: 8,
      justifyContent: "center",
      cursor: disabled ? "not-allowed" : "pointer",
      borderRadius: 32,
      border: 0,
      outline: "none",
      transition:
        "transform 150ms ease, box-shadow 150ms ease, filter 150ms ease, opacity 150ms ease, background 150ms ease",
      backgroundColor: PRIMARY_COLOR,
      opacity: disabled ? 0.6 : 1,

      "&:focus": {
        outline: "2px solid rgba(255, 255, 255, 0.72)",
        outlineOffset: 3,
        boxShadow: `0 0 0 5px ${FOCUS_RING_COLOR}`,
      },
      // keyboard focus visible
      "&:focus-visible": {
        outline: "3px solid rgba(255, 255, 255, 0.92)",
        outlineOffset: 3,
        boxShadow: `0 0 0 7px ${FOCUS_RING_VISIBLE_COLOR}`,
      },
      // Added hover state
      "&:hover": disabled
        ? {}
        : {
            filter: "brightness(1.08)",
          },
      // pointer active (pressed) visual
      "&:active": disabled
        ? {}
        : {
            transform: "translateY(1px) scale(0.99)",
            boxShadow: "0px -1px 0px 0px rgba(0, 0, 0, 0.20) inset",
            filter: "brightness(0.95)",
            opacity: 0.9,
          },

      color: "#fff",
      textAlign: "center",
      textShadow: "0px 4px 4px rgba(0, 0, 0, 0.16)",
      fontSize: 18,
      fontWeight: 600,
    }}
  >
    <Icon_download />
    <div css={{ alignSelf: "stretch", margin: "auto 0" }}>{label}</div>
    {isCaching && <Spinner />}
  </button>
)

export default ActionButton
